module.exports = __webpack_public_path__ + "static/media/icon-orders-active.42f117c3.svg";